import { createStore } from "vuex";

import resource from "./resource";

const store = createStore({
    modules: {
        resource: {
            namespaced: true,
            modules: {
                ...resource,
            },
        },
    },
    state: {},
    getters: {},
    actions: {},
    mutations: {},
});

store.dispatch("resource/auth/loadToken");

export default store;
